import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useReadPoliciesForUserQuery } from '@/shared/redux/api/ident/ident-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const useLoggedInUser = () => {
  const user = useAppSelector(selectUser);
  const { useTenantSettings } = useRbacConfig();
  const { ownerId, isLoadingTenant } = useTenantSettings();
  const { data: policiesData, isLoading: isLoadingPolicies } =
    useReadPoliciesForUserQuery(
      { userId: user?.userId! },
      { skip: !user?.userId },
    );
  const policies =
    policiesData?.readUserRolesForUser?.items?.flatMap(
      ({ policies }) => policies,
    ) ?? [];
  const isAdmin = policies?.some(
    ({ action, resource }) =>
      action.every((a) => a === '*') && resource.every((r) => r === '*'),
  );

  const canViewPage = (type: string) => {
    return policies?.some(
      ({ action }) =>
        action.every((a) => a === '*') ||
        action.every((a) => a.startsWith(type)),
    );
  };

  const isSsoUser = Boolean(user?.attributes?.identities?.length);
  const isMfaEnabled = Boolean(user?.mfaEnabled);
  const isLoggedInUser = (userId?: string) => user?.userId === userId;
  const isOwner = (userId?: string) => userId === ownerId;
  const isLoading = isLoadingPolicies || isLoadingTenant;

  return {
    isAdmin,
    isSsoUser,
    isMfaEnabled,
    isLoading,
    isOwner,
    isLoggedInUser,
    loggedInUser: user,
    canViewPage,
  };
};
